module.exports = __webpack_public_path__ + "static/template_talent_v2-01b5095e7da3e43868772030eee6a6a4.png";